'use strict';

require('console-polyfill');
require('babel-polyfill');

// External Libraries
require('angular-strap');
require("console-polyfill");
require("dragula");

require("moment");
require("angular");
require("angular-loading-bar");
require("angular-animate");
require("angular-sanitize");
require("angular-strap");
require("angular-toastr");
window.introJs = require("intro.js").introJs;

// Template files
require("angular-strap/dist/angular-strap.tpl.js");
require("angular-toastr/dist/angular-toastr.tpls.js");

const angularDragula = require('angular-dragula');

require("../static/components/bootstrap/js/collapse.js");
require("../static/components/bootstrap/js/alert.js");

const Raven = require('raven-js');

if(process.env.SENTRY_DSN) {
    console.log('DSN', process.env.SENTRY_DSN);
    Raven
        .config(process.env.SENTRY_DSN, {
            environment: process.env.RDS_DB_NAME
        })
        .addPlugin(require('raven-js/plugins/angular'), angular)
        .install();

    angular.module('AngularAdmin.debug', ['ngRaven']);
} else {
    console.log('No Sentry configured');
    angular.module('AngularAdmin.debug', []);
}


// Empty module that can be overridden to load custom libs
angular.module('AngularAdmin.extras', [
    'mgcrea.ngStrap.helpers.dateParser',
    'mgcrea.ngStrap.tooltip',
    'mgcrea.ngStrap.datepicker',
    'mgcrea.ngStrap.timepicker',
    'mgcrea.ngStrap.helpers.parseOptions',
    'mgcrea.ngStrap.typeahead',
    'mgcrea.ngStrap.select'
]);

// templates module (separated so we can access templates in main module run function)
angular.module('AngularAdmin.templates', []);

// Declare app level module
angular.module('AngularAdmin', [
    'AngularAdmin.debug',
    'AngularAdmin.extras',
    'AngularAdmin.templates',
    'ngSanitize',
    'ngAnimate',
    'angular-locker',
    'ui.bootstrap.tpls',
    "ui.bootstrap.transition",
    "ui.bootstrap.collapse",
    "ui.bootstrap.accordion",
    "ui.bootstrap.alert",
    "ui.bootstrap.bindHtml",
    "ui.bootstrap.buttons",
    "ui.bootstrap.dropdown",
    "ui.bootstrap.position",
    "ui.bootstrap.modal",
    "ui.bootstrap.pagination",
    "ui.bootstrap.progressbar",
    "ui.bootstrap.rating",
    "ui.bootstrap.tabs",
    "ui.bootstrap.typeahead",
    'angular-loading-bar',
    'toastr',
    'ErrorCatcher',
    angularDragula(angular)
]);

angular.module('AngularAdmin').config([
    '$locationProvider',
    '$sceProvider',
    '$httpProvider',
    'cfpLoadingBarProvider',
    'toastrConfig',
    function ($locationProvider, $sceProvider, $httpProvider, cfpLoadingBarProvider, toastrConfig) {
        // Initialize get if not there
        if (!$httpProvider.defaults.headers.get) {
            $httpProvider.defaults.headers.get = {};
        }
        // Disable IE ajax request caching
        $httpProvider.defaults.headers.get['If-Modified-Since'] = '0';


        cfpLoadingBarProvider.includeSpinner = false;

        angular.extend(toastrConfig, {
            positionClass: 'toast-bottom-center',
            preventOpenDuplicates: true
        });

    }])
    .run(['$rootScope', '$templateCache', function ($rootScope, $templateCache) {

        $templateCache.put('select/select.tpl.html', $templateCache.get('/static/partials/components/bs_select.html'));

        $rootScope.dateFormat = {
            moment: 'MM/DD/YYYY',
            ng: 'MM/dd/yyyy',
            moment_url: 'YYYY-MM-DD'
        };

        $rootScope.graphClass = function ($scope) {
            if ($scope.hoveredMaterial) {
                return "hovered-material-" + $scope.hoveredMaterial;
            }
            return "";
        };

        $rootScope.dbStringSeparator = "!#!#!";

        $rootScope.colorPalette = [
            "#23719F", "#34A7EB", "#5B90AF", "#7AC2EB",
            "#184D6C", "#53C593", "#AC373A", "#F84F54",
            "#BA7375", "#F89A9D", "#EBE828", "#6B6A12",
            "#B8B61F", "#392E6E", "#7C64ED", "#973CBA",
            "#816F87", "#BA923C", "#F0DFA1", "#3A2E13"
        ];

    }]);

angular.module('ErrorCatcher', [])
    .factory('errorHttpInterceptor', ['$q', '$injector', function ($q, $injector) {
        return {
            responseError: function responseError(rejection) {

                // filter out bad request BAD REQUEST(validation) errors
                if (rejection.status !== 400) {
                    // show error toast for errors
                    const toastr = $injector.get("toastr");
                    toastr.error('Server responded: ' + rejection.status + ' ' + rejection.statusText);
                }

                return $q.reject(rejection);
            }
        };
    }]).factory('$exceptionHandler', ["$injector", function ($injector) {
        return function (exception) {
            const toastr = $injector.get("toastr");
            toastr.warning("Ups, something unexpected happened. If you are stuck, please press the 'Help' button.");
            console.error(exception);
            Raven.setUserContext({
                id: window.PdUserId
            });
            Raven.captureException(exception);
        };
    }]).config(['$httpProvider', function ($httpProvider) {
        $httpProvider.interceptors.push('errorHttpInterceptor');
    }]);


require('./helpers.js');
require('./controllers');
require('./directives');
require('./filters');
require('./services');